import {Component, OnInit} from '@angular/core';
import {PublicGroupsComponent} from '../public/public-groups/public-groups.component';
import {PublicStandingsComponent} from '../public/public-standings/public-standings.component';
import {PublicRoundsComponent} from '../public/public-rounds/public-rounds.component';
import {MessageModule} from 'primeng/message';

@Component({
  selector: 'app-public-wp-testing',
  imports: [
    PublicGroupsComponent,
    PublicStandingsComponent,
    PublicRoundsComponent,
    MessageModule
  ],
  templateUrl: './public-wp-testing.component.html',
  styleUrl: './public-wp-testing.component.scss',
})
export class PublicWpTestingComponent implements OnInit {

  public tournamentId: string = '5ed9332a-3724-4c40-9c3d-0d9234db2cf9';
  ngOnInit() {
  }
}
